export enum SELECT_TIME_SLOTS_EXTERNAL_SERVICES {
  listTimeSlots = 'listTimeSlots',
}
